module.exports = __webpack_public_path__ + "static/media/PATS_1-105w.19714479.png";